export const regionsHelper: Record<string, string> = {
  chuy: "CHUI",
  bishkek: "BISHKEK",
  osh: "OSH",
  jalal_abad: "JALAL_ABAD",
  yssyk_kol: "YSSYK_KOL",
  naryn: "NARYN",
  batken: "BATKEN",
  talas: "TALAS",
};
